<template>
  <div class="side-navigation">
    <div class="for-small-width bottom-divider">
      <router-link :to="{ name: 'Home' }">
        <h4 class="link">Home</h4>
      </router-link>

      <router-link :to="{ name: 'About' }">
        <h4 class="link">About us</h4>
      </router-link>

      <router-link :to="{ name: 'Contacts' }">
        <h4 class="link">Contact us</h4>
      </router-link>

      <router-link :to="{ name: 'ListEngagements' }">
        <h4 class="link">Our Engagements</h4>
      </router-link>

      <router-link :to="{ name: 'SearchProjects' }">
        <h4 class="link">Search</h4>
      </router-link>
    </div>

    <!-- LOGGED OUT USERS -->
    <div v-if="!userIsLoggedIn">
      <router-link :to="{ name: 'Login' }">
        <h4 class="link">Login</h4>
      </router-link>

      <router-link :to="{ name: 'UserOnboarding' }">
        <h4 class="link" @click="sendCreateProfileEventGA">Sign Up</h4>
      </router-link>
    </div>

    <!-- ALL LOGGED IN USERS -->
    <div v-if="userIsLoggedIn">
      <router-link :to="{ name: 'EditProfile' }">
        <h4 class="link">My Profile</h4>
      </router-link>

      <router-link :to="{ name: 'FundingHistory' }">
        <h4 class="link">Funding History</h4>
      </router-link>

      <!-- <router-link :to="{ name: 'PaymentInformation' }">
        <h4 class="link">Payment Information</h4>
      </router-link> -->

      <!-- MAKERS ONLY-->
      <div v-if="userIsMaker">
        <router-link :to="{ name: 'NewProject' }">
          <h4 class="link" @click="sendCreateProjectEventGA">Create a Project</h4>
        </router-link>

        <!-- <router-link :to="{ name: 'MakerPayoutOverview' }">
          <h4 class="link">Collect Payment</h4>
        </router-link> -->

        <router-link :to="{ name: 'MakerProjectFeed' }">
          <h4 class="link">My Projects</h4>
        </router-link>

        <router-link :to="{ name: 'PayoutSetup' }">
          <h4 class="link">Update Payout Information</h4>
        </router-link>
      </div>

      <!-- My Impact Page to build out?
      <router-link :to="{ name: 'MyImpact' }">
        <h4 class="link">My Impact</h4>
      </router-link>-->

      <!-- NON-MAKERS ONLY-->
      <div v-if="!userIsMaker">
        <router-link :to="{ name: 'MakerOnboarding' }">
          <h4 class="link" @click="sendCreateProjectEventGA">Create a Project</h4>
        </router-link>
      </div>

      <!-- ACTIVATORS ONLY -->
      <div v-if="userIsActivator" class="top-divider">
        <router-link :to="{ name: 'AssignmentsOverview' }">
          <h4 class="link">My Assignments</h4>
        </router-link>
      </div>

      <div v-if="userIsStaff" class="top-divider">
        <router-link :to="{ name: 'StaffReports' }">
          <h4 class="link">Staff Reports</h4>
        </router-link>
        <router-link :to="{ name: 'StaffActivatorOverview' }">
          <h4 class="link">Staff Activator Overview</h4>
        </router-link>
        <router-link :to="{ name: 'StaffMakerOverview' }">
          <h4 class="link">Staff Maker Overview</h4>
        </router-link>
        <!-- <router-link :to="{ name: 'StaffPaymentsOverview' }">
          <h4 class="link">Staff Payments Overview</h4>
        </router-link>
        <router-link :to="{ name: 'StaffPayoutsOverview' }">
          <h4 class="link">Staff Payouts Overview</h4>
        </router-link> -->
      </div>

      <div class="top-divider">
        <a @click="handleLogout">
          <h4 class="link">Logout</h4>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Auth from '@/services/auth/index'

export default {
  name: 'SideNavigation',
  computed: {
    ...mapGetters(['userIsLoggedIn', 'userIsMaker', 'userIsActivator', 'userIsStaff']),
  },
  methods: {
    handleLogout() {
      Auth.logout()
      this.$router.push({ name: 'Login' })
    },
    /** Google Analytics - Send "Click 'Create a Project'" event to GA. */
    sendCreateProjectEventGA() {
      this.$ga.event({
        eventCategory: "Click 'Create a Project'",
        eventAction: 'From Side Navigation',
      })
    },
    /** Google Analytics - Send "Start Creating Profile" event to GA. */
    sendCreateProfileEventGA() {
      this.$ga.event({
        eventCategory: 'Start Creating Profile',
        eventAction: 'From Side Navigation',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.side-navigation {
  width: 90%;
  max-width: 300px;
  background-color: #fff;
  position: absolute;
  z-index: 99;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
}

.link {
  padding: 0.5rem 1rem;
  margin-bottom: 0rem;
  font-size: 1rem;
  cursor: pointer;
}

.for-small-width {
  @media screen and (min-width: 900px) {
    display: none;
  }
}

.top-divider:before,
.bottom-divider:after {
  display: block;
  content: '';
  height: 2px;
  width: 100%;
  margin: 0.4rem 0;
  background-color: #f5f5f5;
}

.create-project-top {
  margin-bottom: 0;
}

.create-project-bottom {
  padding-left: 1rem;
}

.extra-links {
  border-top: 1px solid #aaa;
}

.extra-links h6 {
  font-size: 0.8rem;
  margin: unset;
}
</style>
